import React, { useMemo, useState, useEffect } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { useLocation, useNavigate } from 'react-router-dom';
import Overview from './Overview';
import AllPlans from './AllPlans';
import './OrgSubscription.scss';
import { routes } from '../../../../routes/allRoutes';

const OrgSubscriptionTabs = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const query = useMemo(() => new URLSearchParams(location.search), [location.search]);

    // default to Overview (index 0); All Plans is index 1
    const initialIndex = query.get('tab') === 'all' ? 1 : 0;
    const [activeIndex, setActiveIndex] = useState<number>(initialIndex);

    useEffect(() => {
        // Keep activeIndex in sync if URL changes externally
        const idx = new URLSearchParams(location.search).get('tab') === 'all' ? 1 : 0;
        setActiveIndex(idx);
    }, [location.search]);

    const onTabChange = (e: { index: number }) => {
        setActiveIndex(e.index);
        // update URL query param to reflect current tab for deep-linking
        const tabParam = e.index === 1 ? 'all' : 'overview';
        navigate(`${routes.orgSubscriptions}?tab=${tabParam}`, { replace: true });
    };

    return (
        <div className="org-subscription-tabs">
            <TabView activeIndex={activeIndex} onTabChange={onTabChange}>
                <TabPanel header="Overview">
                    <Overview />
                </TabPanel>
                <TabPanel header="All Plans">
                    <AllPlans />
                </TabPanel>
            </TabView>
        </div>
    );
};

export default OrgSubscriptionTabs;
